export const denormalizePhoneForBackend = (formattedPhone: string): string => {
  if (!formattedPhone) return ''
  return formattedPhone.replace(/\D/g, '')
}
